<template>
  <div>
    <div v-if="deleteConfirm">
      <h3>Suppression d'un utilisateur</h3>
      <p>Attention, <strong>cette opération est irréversible</strong>. Êtes-vous sûr(e) de vouloir continuer ?</p>
      <b-row class="mt-5" v-if="getUserSession().id !== oldUser.id && isAdmin()">
        <b-col align-self="center" class="text-center">
          <b-button variant="primary" @click.prevent="deleteUser(oldUser.id)">Confirmer</b-button>
        </b-col>
        <b-col align-self="center" class="text-center">
          <b-button variant="danger" @click.prevent="cancelDelete()">Annuler</b-button>
        </b-col>
      </b-row>
    </div>
    <!-- Container -->
    <div class="profile-type-container" v-else>

      <!-- Form -->
      <b-form @submit="patch" :id="`app-patch-user-form${_uid}`">

        <!-- First name -->
        <UserInputType type="text"
                      label="Prénom"
                      place-holder="Entrez votre Prénom"
                      user-property="firstName"/>

        <!-- Last name -->
        <UserInputType type="text"
                      label="Nom"
                      place-holder="Entrez votre Nom"
                      user-property="lastName"/>

        <!-- email -->
        <UserInputType type="email"
                      label="Email"
                      place-holder="Entrez votre Adresse Email"
                      user-property="email"/>

        <!-- Is active? -->
        <UserInputType type="isActive"
                      label="Compte actif ?"
                      user-property="isActive"
                      v-if="getUserSession().id !== oldUser.id && isAdmin()"/>

        <!-- Submit -->
        <b-button type="submit"
                  :form="`app-patch-user-form${_uid}`"
                  variant="primary"
                  v-if="getUserProfileCloneUpdated()">
          Sauvegarder
        </b-button>

      </b-form>

      <hr>
      <!-- Roles -->
      <RolesType :read-only="!(getUserSession().id !== oldUser.id && isAdmin())" @rolesUpdated="sendProfileUpdateEvent()"/>

      <hr v-if="getUserSession().id !== oldUser.id && isAdmin()">
      <!-- Reset Password -->
      <ResetPasswordType />

      <hr v-if="getUserSession().id !== oldUser.id && isAdmin()">
      <b-row v-if="getUserSession().id !== oldUser.id && isAdmin()">
        <b-col align-self="center" class="text-center">
          <b-button variant="danger" href="#" @click.prevent="deleteConfirm = true">Supprimer l'utilisateur</b-button>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProfileType',
  props: {
    oldUser: { type: Object, required: false },
  },
  data() {
    return {
      dataChanged: false,
      user: {},
      deleteConfirm: false,
    };
  },
  computed: {
    ...mapGetters({
      userProfileClone: 'getUserProfileClone',
    }),
  },
  methods: {
    ...mapGetters([
      'getUserProfileCloneUpdated',
      'getUserSession',
      'isAdmin',
      'isAgent',
    ]),
    patch(event) {
      event.preventDefault();
      event.stopPropagation();
      this.$store.commit('setGlobalSpinnerShow', true);
      this.$store.dispatch('patchUser')
        .then((userUpdated) => {
          // Show success toast
          const toast = {
            show: true,
            message: 'Modification effectuée avec succès !',
            variant: 'success',
            duration: 3000,
          };
          this.$store.commit('setGlobalToaster', toast);
          this.$store.commit('setUserProfileClone', userUpdated);
          this.$emit('profileUpdated');
        }, (error) => {
          // Update error form in store
          this.$store.commit('setFormPatchUserError', error);
        })
        .finally(() => {
          this.$store.commit('setGlobalSpinnerShow', false);
        });
    },
    deleteUser(user) {
      axios.delete(`users/${user}`)
      .then((response) => {
        const toast = {
          show: true,
          message: 'Utilisateur supprimé avec succès.',
          variant: 'success',
          duration: 3000,
        };

        this.$store.commit('setGlobalToaster', toast);
        this.$emit('updateUsers', response.data);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 400) {
            const toast = {
              show: true,
              message: 'Erreur : Impossible de supprimer cet utilisateur. Des aléas sont liés à ce dernier.',
              variant: 'danger',
              duration: 3000,
            };

            this.$store.commit('setGlobalToaster', toast);
          }
        } else {
          console.error(error);
        }
      });
    },
    cancelDelete() {
      this.deleteConfirm = false;
    },
    sendProfileUpdateEvent() {
      this.$emit('profileUpdated');
    }
  },
  beforeMount() {
    this.$store.commit('setUserProfileClone', this.oldUser);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .profile-user-avatar {
    display: block;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 2px solid rgba(150, 150, 150, 0.45);
  }

  .profile-type-container {
    max-width: 960px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/user/ProfileType.vue